'use strict';

var batcher = require('./batcher.cjs');

const { schedule: microtask} = 
/* @__PURE__ */ batcher.createRenderBatcher(queueMicrotask, false);

exports.microtask = microtask;
//# sourceMappingURL=microtask.cjs.map
